import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

export default ({ productStatuses, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (productStatuses.loading) {
      return "is Loading";
    }
    if (isEmpty(productStatuses.data)) {
      return <p className="is-size-2 has-text-centered has-text-grey">Found Nothing</p>;
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {productStatuses.data.map(productStatus => (
            <tr key={productStatus.id}>
              <td>
                <a>{productStatus.id}</a>
              </td>
              <td>{productStatus.status}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link to={`/product-status/${productStatus.id}/edit`} className="button  is-link is-small">
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(productStatus.id)}
                    to={`/product-status/${productStatus.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/ProductStatus/Index/Table.js